import { FormConfig, Text } from '@lbcamden/lib-react';
import { z } from 'zod';

import { camdenEmailAddressSchema } from '~/common/schemas/people';

import { commonFormConfig, commonFormSchema } from '../config';
import { ReferrerEmailLabel } from './RecordAssessmentDialog.styled';

export type RecordAssessmentFormValues = z.infer<typeof formSchema>;

export const formSchema = z.object({
  pcfraNeeded: z.enum(['Yes', 'No']),
  ...commonFormSchema.shape,
  referrerEmail: camdenEmailAddressSchema.optional(),
});

export const formConfig: FormConfig<RecordAssessmentFormValues> = {
  fieldConfigs: {
    ...commonFormConfig.fieldConfigs,
    pcfraNeeded: {
      label: 'Is a PCFRA needed at this time?',
    },
    referrerEmail: {
      label: (
        <ReferrerEmailLabel>
          <Text $weight={600} variant="lead">
            Notify a referrer of this decision?
          </Text>
          <Text>
            If you&apos;d like to automatically notify someone of this decision, enter their email
            address below
          </Text>
        </ReferrerEmailLabel>
      ),
      placeholder: '@camden.gov.uk',
    },
  },
};
